import {AntragTicketSepaDTO} from "./AntragTicketSepaDTO";
import {SchuleDTO} from "../schule/SchuleDTO";
import {SchuljahrDTO} from "../schuljahr/SchuljahrDTO";
import {KlasseDTO} from "../klasse/KlasseDTO";
import {TicketDTO} from "../ticket/TicketDTO";
import {HaltestelleDTO} from "../haltestelle/HaltestelleDTO";
import {TicketAntragStatus} from "./TicketAntragStatus";
import {SchuelerDTO} from "../schueler/SchuelerDTO";
import {Ermaessigung} from "./Ermaessigung";
import {AntragTicketSonderfallDto} from "./AntragTicketSonderfallDto";
import {Wegtyp} from "./Wegtyp";
import {BildungsgangDTO} from "../bildungsgang/BildungsgangDTO";
import {Geschlecht} from "../benutzer/Geschlecht";
import {Land} from "../land/Land";
import {AntragAttachmentDto} from "./AntragAttachmentDto";
import {SchoolLevel} from "../schule/SchoolLevel";
import {AntragstellerEmbeddedDTO} from "./AntragstellerEmbeddedDTO";

export interface AntragTicketDTO {

  id: number;
  antragId: string;
  antragTicketSepa: AntragTicketSepaDTO;
  name: string;
  vorname: string;
  strasse: string;
  plz: string;
  ort: string;
  geburtsdatum: Date;
  aboGueltigkeit: Date;
  email: string;
  emailSchueler: string;
  telefonnummer: string;
  schwerbehinderung: boolean;
  schule: SchuleDTO;
  schuljahr: SchuljahrDTO;
  klasse: KlasseDTO;
  schoolLevel: SchoolLevel;
  geschlecht: string;
  ticket: TicketDTO;
  einstieghaltestelle: HaltestelleDTO;
  ausstieghaltestelleHinweg: HaltestelleDTO;
  referenzFuerZahlungen: string;
  abonnementnummerAntrag: string;
  antragsdatum: Date;
  genehmigungsdatum: Date;
  bemerkungAntragsteller: string;
  einverstaendnisErklaerung: boolean;
  marketingfreigabe: boolean;
  geschwisterkind1: SchuelerDTO;
  geschwisterkind2: SchuelerDTO;
  geschwisterkind3: SchuelerDTO;
  geschwisterkind4: SchuelerDTO;
  geschwisterkind5: SchuelerDTO;
  fahrkostenberechtigt: boolean;
  umgezogen: boolean;
  alteTicketsLiegenBei: boolean;
  alteTicketsWerdenZurueckgesandt: boolean;
  bemerkungSchule: string;
  ausgabedatum: Date;
  bildungsgangdatum: Date;
  internerVermerkSchule: string;
  preisstufe: number;
  preisstufeRequired: number;
  eigenanteil: number;
  zuzahlung: number;
  betragSumme: number;
  gesamtforderung: number;
  abmeldedatum: Date;
  bemerkungSchultraeger: string;
  ermaessigung: Ermaessigung;
  internerVermerkSchultraeger: string;
  bestelldatum: Date;
  schuelernummer: string;
  richtigkeitDerAngaben: boolean;
  preisstufeVerkehrsunternehmen: string;
  exportRest: Date;
  nachrichtAnAntragsteller: string;
  loggedOffTransferred: boolean;
  externalId: string;
  status: TicketAntragStatus;
  schueler: SchuelerDTO;
  land: Land;
  vormundName: string;
  vormundVorname: string;
  vormundStrasse: string;
  vormundOrt: string;
  vormundPlz: string;
  vormundLand: Land;
  vormundGeburtsdatum: Date;
  vormundTelefonnummer: string;
  vormundEmail: string;
  vormundGeschlecht: Geschlecht;
  wegtyp: Wegtyp;
  bildungsgang: BildungsgangDTO;
  fachbereich: string;
  schultageJeWoche: number;
  praktikumHinweis: string;
  praktikumStelle: string;
  praktikumStrasse: string;
  praktikumOrt: string;
  praktikumPlz: string;
  praktikumLand: Land;
  praktikumAdresszusatz: string;
  praktikumStartdatum: Date;
  praktikumEnddatum: Date;
  praktikumstageJeWoche: number;
  sonderfallEnabled: boolean;
  sonderfaelle: AntragTicketSonderfallDto[];
  bezugAsylbewerberleistungsgesetz: boolean;
  adresszusatz: string;
  vormundAdresszusatz: string;
  zustimmungGesetzlicherVertreter: boolean;

  praktikumsvertragId: number;
  bezugNachweisId: number;

  isVormundadresseAbweichend: boolean;
  postkorbReference: string;
  attachments: AntragAttachmentDto[];

  antragstellerDto: AntragstellerEmbeddedDTO;

  angabenKorrekt: boolean;
  tarifbestimmungenZugestimmt: boolean;

}

/**
 * Returns true if the given ticket/Fahrkosten has an active Postkorb (Kommunalportal
 * inbox) channel to send messages to. This is the single canonical way to decide
 * Postkorb-vs-email routing on the frontend - do not inline `!!x.postkorbReference`
 * checks, use this function. Accepts any object shaped like `{ postkorbReference }`
 * (e.g. `AntragTicketDTO` or `FahrkostenDTO`), since both carry the same field.
 *
 * Mirrors `AntragTicket.hasPostkorbChannel()` on both backends - see there for the
 * full explanation of when `postkorbReference` is (and isn't) set.
 */
export function hasPostkorbChannel(ticket: { postkorbReference?: string | null } | null | undefined): boolean {
  return !!ticket?.postkorbReference;
}





























